module["exports"] = ["Not relevant for Israel"];